import React, { useState, useEffect ,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import { Ledgerlist,DeleteLedger,GetSpecialOpeningBalance } from '../store/slices/ledger';
import Loader from '../common/Loader';
import { useDispatch, useSelector } from 'react-redux';
import Table from '../common/Table';
import AdminLayout from './AdminLayout';
import { FaFileExcel } from "react-icons/fa";
import {toast } from 'react-hot-toast';
import {excelLedgerDownload } from "../common/ExcelDownload"
import AddOpeningBalancePop from './AddOpeningBalancePop';

const LedgerList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef=useRef(null)

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [ledgerList, setLedgerList] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
  const [selectAll, setSelectAll] = useState(false);
 const [columns, setcolumns] = useState([
  { header: 'Checkbox', field: 'Checkbox' },
  { header: 'Name', field: 'ledger' },
  { header: 'Group Name', field: 'group_name' },
  { header: 'Opening Balance', field: 'balance_combined' },
  {
    header: 'Actions',
    field: 'actions',
    isAction: true,
    getActionButtons: (item) => {
      // Always show "View Ledger Entries"
      let buttons = [{ name: 'View Ledger Entries', className: 'btn-default' }];

      // Show Edit & Delete only if is_default === "0"
      if (item?.is_default === "0") {
        buttons.push(
          { name: 'Edit', className: 'btn-default' },
          { name: 'Delete', className: 'btn-cancel' }
        );
      }
      // Show Add Opening Balance only if is_default === "1"
      if (item?.is_default === "1") {
        buttons.push({ name: 'Opening Balance', className: 'btn-default' });
      }
      return buttons;
    }
  }
]);

 

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');

  const [showOpeningModal, setShowOpeningModal] = useState(false);
  const [selectedLedger, setSelectedLedger] = useState(null);
  const [specialOpeningData, setSpecialOpeningData] = useState(null);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
     navigate(`/edit/ledger/${item?.id ? item?.id : null}`)
  };
  const handleView = (item) => {
    navigate(`/ledgerdetails/${item?.id ? item?.id : null}`)
 };

  const handleAddOpeningBalance = async (item) => {
    // Fetch existing opening balance (if any) before showing the modal
    setSelectedLedger(item);
    setIsLoading(true);
    try {
      const payload = { profile_id: id, ledger_id: item?.id };
      const res = await dispatch(GetSpecialOpeningBalance(payload)).unwrap();
      setSpecialOpeningData(res?.record || null);
    } catch (err) {
      toast.error(err?.message || "Unable to fetch opening balance");
    } finally {
      setIsLoading(false);
      setShowOpeningModal(true);
    }
  };

  const handleOpeningSuccess = () => {
    // Refresh ledger list after successful update
    fetchLedger();
  };

  const handleCloseOpeningModal = () => {
    setShowOpeningModal(false);
    setSelectedLedger(null);
    setSpecialOpeningData(null);
  };



    useEffect(() => {
      fetchLedger();
    }, [dispatch]);

    const fetchLedger = async () => {
      setIsLoading(true);
      try {
        const data = await dispatch(Ledgerlist()).unwrap();
        setIsLoading(false);
        setLedgerList(data?.data);
      } catch (error) {
        setIsLoading(false);
        setLedgerList([]);
        console.log('Error fetching invoices:', error.message);
      }
    };

    const handleDelete = (item) => {
      const confirmDelete = window.confirm('Are you sure you want to delete this Ledger?');
      if (confirmDelete) {
        setIsLoading(true);
        dispatch(DeleteLedger({ ledger_id: item.id,profile_id: id }))
          .unwrap()
          .then(() => {
            setIsLoading(false);
            fetchLedger(); // Refresh the invoice list
          })
          .catch(({ message }) => {
            // console.log(message)
            setIsLoading(false);
            toast.error(message);
          });
      }
    };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const search = searchQuery?.toLowerCase() || '';
  // Filter data based on search query
  const filteredParties = ledgerList?.filter(party => 
    party?.ledger?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.group_name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    party?.state?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

      const handleExcelDownload = () => {
        if (!ledgerList || ledgerList.length === 0) {
            alert("No data available for download.");
            return;
        }
    
        const selectedInvoices = selectAll && ledgerList.length > 0
            ? ledgerList.map(invoice => invoice.id)
            : selectedRows;
    
        if (!selectedInvoices || selectedInvoices.length === 0) {
            alert("Please select at least one Ledger.");
            return;
        }
    
        const selectedData = ledgerList.filter(invoice => selectedInvoices.includes(invoice.id));
    
        if (selectedData.length === 0) {
            alert("No matching Ledger found.");
            return;
        }
    
        try {
          excelLedgerDownload(selectedData, "Ledger.xlsx");
            toast.success("Downloading Excel file successfully!");
        } catch (error) {
            console.error("Error downloading Excel file:", error);
            alert("Failed to download the Excel file. Please try again.");
        }
    };
  return (
    <AdminLayout>
        {isLoading && <Loader />}
          <div className="row content-body">
            <div className="container-fluid">
              <div className="page-header">
                <div>
                  <h2 className="main-content-title tx-24 mg-b-5">Ledger</h2>
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                    Ledger List
                    </li>
                  </ol>
                </div>
                <div className="d-flex justify-content-end">
                  <button className="btn ripple btn-default" onClick={() => navigate('/addLedger')}>
                  Add Ledger
                  </button>
                    <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                                     Export Excel <FaFileExcel/>
                                                    </button>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12"> 
                 <Table
                    columns={columns}
                    data={filteredParties} 
                    tableRef={tableRef}
                    pageSize={pageSize}
                    setPageSize={setPageSize}
                    currentPage={currentPage}
                    totalCount={filteredParties.length} 
                    onPageChange={handlePageChange}
                    handleEdit={handleEdit}
                    handleView={handleView}
                    handleDelete={handleDelete}
              handleAddOpeningBalance={handleAddOpeningBalance}
                    handleSearchChange={handleSearchChange}
                    selectedRows={selectedRows}
                    setSelectedRows={setSelectedRows} 
                    selectAll={selectAll} 
                     setSelectAll={setSelectAll} 
                  />
                </div>
              </div>
            </div>
          </div>
        {/* Add Opening Balance modal */}
        <AddOpeningBalancePop
          show={showOpeningModal}
          onClose={handleCloseOpeningModal}
          ledgerItem={selectedLedger}
          onSuccess={handleOpeningSuccess}
          specialOpeningData={specialOpeningData}
        />
      </AdminLayout>
  );
};

export default LedgerList;
